import { BaseBus } from "./BaseBus";

export class SubcoOrderDetail extends BaseBus {
    constructor(data: SubcoOrderDetail) {
        super(data);
    }
    orderDetailId: any;
    orderId: any;
    dispatchId: any;
    inventoryBillingCodeId: any;
    supplierId: any;
    inventoryNumber: string;
    inventoryDesc: string;
    amount: number;
    supplierName: string;
    orderNumber: string;
}
